'use strict';
angular.module('manageSysCategoryRelationModifyModule', [])
    .controller('manageSysCategoryRelationModifyCtrl', ['$scope', '$timeout', '$modalInstance', 'trsHttpService', 'websiteLeftService', 'item', 'trsspliceString',
        function($scope, $timeout, $modalInstance, trsHttpService, websiteLeftService, item, trsspliceString) {
            initStatus();
            initData();
            /**
             * [initStatus description] 初始化状态222
             */
            function initStatus() {
                $scope.params = {
                    serviceid: 'mlf_sharedoc',
                    methodname: 'queryCategorysWithOutRight',
                    IsCore: 'false',
                };
                $scope.data = {
                    selectedArray: angular.isDefined(item) ? item : [],
                    selectedNode: {},
                    category: {},
                    expanded: [],
                    selectedArrayId: []
                };
                $scope.status = {
                    treeOptions: {
                        nodeChildren: "CHILDLIST",
                        dirSelectable: true,
                        allowDeselect: false,
                        injectClasses: {
                            ul: "a1",
                            li: "a2",
                            liSelected: "a7",
                            iExpanded: "a3",
                            iCollapsed: "a4",
                            iLeaf: "a5",
                            label: "a6",
                            labelSelected: "a8"
                        },
                        isLeaf: function(node) {
                            return node.CHILDLIST === undefined || node.CHILDLIST.length == 0;
                        }
                    }
                };
            }
            /**
             * [initData description] 初始化数据
             */
            function initData() {
                $scope.data.selectedArrayId = angular.isDefined(item) ? trsspliceString.spliceString(item, 'CATID', ',').split(',') : [];
                requestTree();
            };
            /**
             * [requestTree description] 获取树
             */
            function requestTree() {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, "get")
                    .then(function(data) {
                        angular.forEach(data, function(value, key) {
                            if (value.CHILDLIST == undefined) {
                                value.CHILDLIST = [];
                            };
                        });
                        $scope.data.category.CHILDLIST = data;
                        $scope.data.expanded.push(data[0]);
                    });
            };
            /**
             * [selectDoc description] 单选
             */
            $scope.selectDoc = function(node) {
                if ($scope.data.selectedArrayId.indexOf(node.ID) < 0) {
                    $scope.data.selectedArray.push(node);
                    $scope.data.selectedArrayId.push(node.ID);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArrayId.indexOf(node.ID), 1);
                    $scope.data.selectedArrayId.splice($scope.data.selectedArrayId.indexOf(node.ID), 1);
                }
            };
            /**
             * [chooseDept description] 选择部门
             */
            $scope.chooseDept = function(node) {
                if (node.CHILDLIST != undefined) return;
                if ($scope.data.selectedArrayId.indexOf(node.ID) < 0) {
                    $scope.data.selectedArray.push(node);
                    $scope.data.selectedArrayId.push(node.ID);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArrayId.indexOf(node.ID), 1);
                    $scope.data.selectedArrayId.splice($scope.data.selectedArrayId.indexOf(node.ID), 1);
                }
            };
            /**
             *[getSuggestions description]搜索栏目
             * @param  {[type]}value  [description] 输入部门名称
             * return {[type]}   null  [description]
             */
            var promise;
            $scope.getSuggestions = function(value, type) {
                if (value === "")
                    return;
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                // var siteid = (type == 'website' ? $scope.data.website.selectedItem.SITEID : $scope.data.app.selectedItem.SITEID);
                promise = $timeout(function() {
                    var params = {
                        serviceid: "mlf_sharedoc",
                        methodname: "searchShareCategory",
                        SearchKey: value,
                    };
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get")
                        .then(function(data) {
                            return data;
                        });
                }, 500);
                return promise;
            };
            $scope.$watch("data.column", function(newValue, oldValue) {
                if (angular.isObject(newValue)) {
                    // $scope.status.isRequest = true;
                    // locationChannelTree(newValue.CATEGORYID);
                    if ($scope.data.selectedArrayId.indexOf(newValue.CATEGORYID) < 0) {
                        $scope.data.selectedArray.push(newValue);
                        $scope.data.selectedArrayId.push(newValue.CATEGORYID);
                    }
                    $scope.data.column = newValue.SUGGESTION;
                }
            });
            /**
             * [locationChannelTree description] 根据栏目ID定位栏目树
             * @param  {[type]} channelid [description] 栏目ID
             * @return {[type]}           [description]
             */
            function locationChannelTree(channelid) {
                var href = window.location.hash.substring(0, window.location.hash.indexOf("?")).split("/")[4];
                var platform = href == 'waitcompiled' && 1 || href == 'pending' && 2 || href == 'signed' && 3 || parseInt($stateParams.wzplatform) + 1;
                websiteLeftService.positionSelectChannel($scope.data.category.CHILDLIST, channelid, platform, $scope.expandedTest).then(function(channel) {
                    $scope.selectedNode = channel;
                });
            }
            /**
             * [deleteTrack description] 删除已选
             */
            $scope.deleteTrack = function(index, item) {
                $scope.data.selectedArray.splice(index, 1);
                $scope.data.selectedArrayId.splice(index, 1);
            };
            /**
             * [cancel description] 取消
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
            /**
             * [confirm description] 确定
             */
            $scope.confirm = function() {
                $modalInstance.close($scope.data.selectedArrayId);
            };
        }
    ]);